import React from 'react';

export function CategoryCard() {
  return <></>;
}
